/** Client preference: show/hide MMEC Companion modal popups (server may still push state). */

export const COMPANION_POPUP_SETTINGS_KEY = 'mmec-companion-popup-settings';
export const COMPANION_POPUP_SETTINGS_CHANGED = 'mmec-companion-popup-settings-changed';

export interface CompanionPopupSettings {
  /** When false, companion modal popups are suppressed; chat banner still shows last message. */
  popupsEnabled: boolean;
}

export const DEFAULT_COMPANION_POPUP_SETTINGS: CompanionPopupSettings = {
  popupsEnabled: true,
};

export function loadCompanionPopupSettings(): CompanionPopupSettings {
  try {
    const raw = localStorage.getItem(COMPANION_POPUP_SETTINGS_KEY);
    if (!raw) return { ...DEFAULT_COMPANION_POPUP_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<CompanionPopupSettings>;
    return {
      popupsEnabled: parsed.popupsEnabled !== false,
    };
  } catch {
    return { ...DEFAULT_COMPANION_POPUP_SETTINGS };
  }
}

export function saveCompanionPopupSettings(settings: CompanionPopupSettings): void {
  try {
    localStorage.setItem(COMPANION_POPUP_SETTINGS_KEY, JSON.stringify(settings));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(
    new CustomEvent(COMPANION_POPUP_SETTINGS_CHANGED, { detail: settings }),
  );
}
